import React, { useState, useEffect } from "react";
import {
  ShoppingCartOutlined,
  HeartOutlined,
  HeartFilled,
} from "@ant-design/icons";
import { Card, Typography, Rate, Button, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import "./ListaProductoItem.scss";
import { obtenerNombreCategoria } from "../../utils/categorias/categoriaUtils";
import { useUser } from "../../context/UserContext";
import { toast } from "sonner";

const { Title, Text } = Typography;

export const ListaProductoItemBuscador = ({
  producto,
  addToCart,
  favorite,
  isFavorite,
}) => {
  const { userData } = useUser();
  const navigate = useNavigate();
  const isMesesSinIntereses = producto.mesesSinIntereses || false;
  const detalleUrl = producto.tipo === "servicio" ? `/servicio/${producto.id}` : `/producto/${producto.id}`;
  const [nombreCategoria, setNombreCategoria] = useState("");
  const [localIsFavorite, setLocalIsFavorite] = useState(isFavorite);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const imageUrl =
    Array.isArray(producto?.imagen) && producto.imagen.length > 0
      ? typeof producto.imagen[0] === "string"
        ? producto.imagen[0]
        : producto.imagen[0]?.url
      : typeof producto?.imagen === "string"
      ? producto.imagen
      : "";

  useEffect(() => {
    obtenerNombreCategoria(producto.categoria)
      .then((nombre) => setNombreCategoria(nombre))
      .catch((error) => console.error("Error al obtener categoría:", error));
  }, [producto.categoria]);

  useEffect(() => {
    setLocalIsFavorite(isFavorite);
  }, [isFavorite]);

  const handleToggleFavorite = (e) => {
    e.preventDefault(); 
    e.stopPropagation(); 
    if (!buttonDisabled) {
      if (!userData) {
        toast.error("Inicia sesión para agregar a favoritos.");
        return;
      }
      favorite(!localIsFavorite);
      setLocalIsFavorite(!localIsFavorite);
      setButtonDisabled(true);
      setTimeout(() => setButtonDisabled(false), 1000);
    }
  };

return (
    <Card
      hoverable
      className="product-card-item"
      onClick={() => navigate(detalleUrl)}
      cover={
        <div className="card-image-container">
          <Link
            to={detalleUrl}
            onClick={(e) => e.stopPropagation()}
            style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            {imageUrl ? (
              <img
                alt={producto.nombre || "Artículo"}
                src={imageUrl}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            ) : (
              <div className="card-image-placeholder">
                <span>Sin imagen</span>
              </div>
            )}
          </Link>
          <button 
            type="button"
            onClick={handleToggleFavorite} 
            className={`fav-button ${localIsFavorite ? 'active' : ''}`}
            disabled={buttonDisabled}
          >
            {localIsFavorite ? <HeartFilled /> : <HeartOutlined />}
          </button>
          
          {/* Tag de MSI sobre la imagen para atracción visual inmediata */}
          {isMesesSinIntereses && (
            <div className="msi-badge-overlay">
              <span>MSI</span>
            </div>
          )}
        </div>
      }
    >
      <div className="card-body-content">
        <Text className="category-tag" ellipsis>{nombreCategoria}</Text>
        <Title level={5} ellipsis={{ rows: 2 }} className="product-title">
          {producto.nombre}
        </Title>
        
        {/* Texto explícito de MSI debajo del título */}
        {isMesesSinIntereses && (
          <Text className="msi-text-promo">Hasta 12 meses sin intereses</Text>
        )}

        <div className="rating-section">
          <Rate disabled allowHalf value={producto.calificacion || 0} />
          <span className="rating-count">({producto.resennaCount || 0})</span>
        </div>

        <div className="stock-info">
          {producto.tipo === "servicio" && producto.horaInicio && producto.horaFin ? (
            <Tag color="blue">{`${producto.horaInicio} - ${producto.horaFin}`}</Tag>
          ) : producto.stock !== undefined ? (
            <span className={`stock-status ${producto.stock > 0 ? 'in-stock' : 'out-of-stock'}`}>
              {producto.stock > 0 ? `Stock: ${producto.stock}` : "Agotado"}
            </span>
          ) : null}
        </div>
      </div>

      <div className={`card-footer-price ${isMesesSinIntereses ? 'msi-bg' : ''}`}>
        <div className="price-container">
          <span className="currency">$</span>
          <span className="amount">{producto.total}</span>
        </div>
        {producto.tipo !== "servicio" && (
          <div className="cart-btn-wrapper">
             <Button 
              type="text" 
              icon={<ShoppingCartOutlined />} 
              onClick={(e) => {
                e.stopPropagation();
                addToCart(producto);
              }}
              className="cart-btn"
            />
          </div>
        )}
      </div>
    </Card>
  );
};